export const breadcrumb = {
  title: 'SMS-mailings',

  mailing: {
    index: 'Mailing list',
    create: 'Create mailing'
  },

  message: {
    title: 'Messages',
    index: 'Incoming messages',
    setting: 'Configure Incoming Messages',

    tab: {
      index: 'Incoming messages',
      setting: 'Settings'
    }
  },

  template: {
    index: 'Templates'
  },

  sender: {
    index: 'Senders'
  }
};
